export enum EndpointsStatusesQueryKeys {
  Status = '/txn-info-receipt',
  Repay = 'repay',
}

export enum StatusQueryKeys {
  Status = 'status',
}
